<form *ngIf="objectOwnerFormGroup && property" [formGroup]="objectOwnerFormGroup">
  <div formArrayName="objectOwners">
    <div *ngFor="let owner of objectOwners.controls; let i = index" [formGroupName]="i" class="box mb-4">

      <div class="is-flex is-justify-content-space-between mb-2">
        <strong>Eigentümer {{ i + 1 }}</strong>
        <button
            type="button"
            class="delete is-small"
            aria-label="Eigentümer entfernen"
            title="Eigentümer entfernen"
            (click)="removeObjectOwner(i)"
            *ngIf="objectOwners.length > 1">
        </button>
      </div>

      <!-- Radio Buttons -->
      <div class="field is-grouped mb-3">
        <div class="control">
          <label class="radio">
            <input type="radio"
                   [value]="ObjectOwnerType.COMPANY"
                   formControlName="objectOwnerType"
                   (change)="onObjectOwnerTypeChange(i, ObjectOwnerType.COMPANY)">
            Unternehmen
          </label>
        </div>
        <div class="control">
          <label class="radio">
            <input type="radio"
                   [value]="ObjectOwnerType.PRIVATE"
                   formControlName="objectOwnerType"
                   (change)="onObjectOwnerTypeChange(i, ObjectOwnerType.PRIVATE)">
            Privatperson
          </label>
        </div>
      </div>

      <!-- Input Fields -->
      <div class="columns is-multiline">
        <div class="column" [ngClass]="isPrivate(owner) ? 'is-3' : 'is-4'">
          <label class="label is-size-7" for="ownerFirstnameInput">
            {{ isPrivate(owner) ? 'Vorname(n)' : 'Vorname (Vertreter)' }}
          </label>
          <input class="border-input" type="text" id="ownerFirstnameInput" formControlName="firstname"
                 [placeholder]="isPrivate(owner) ? 'Vorname(n)' : 'Vorname (Vertreter)'"
                 [ngClass]="{'has-error': FormUtils.hasError(owner.get('firstname'))}">
        </div>

        <div class="column" [ngClass]="isPrivate(owner) ? 'is-3' : 'is-4'">
          <label class="label is-size-7" for="ownerLastnameInput">
            {{ isPrivate(owner) ? 'Nachname' : 'Nachname (Vertreter)' }}
          </label>
          <input class="border-input" type="text" id="ownerLastnameInput" formControlName="lastname"
                 [ngClass]="{'has-error': FormUtils.hasError(owner.get('lastname'))}"
                 [placeholder]="isPrivate(owner) ? 'Nachname' : 'Nachname (Vertreter)'">
        </div>

        <div *ngIf="isPrivate(owner)" class="column is-3">
          <label for="ownerBirthdateInput" class="label is-size-7">Geburtsname (optional)</label>
          <input class="border-input" type="text" id="ownerBirthdateInput" formControlName="birthName"
                 [ngClass]="{'has-error': FormUtils.hasError(owner.get('birthName'))}"
                 placeholder="Geburtsname (optional)">
        </div>

        <div *ngIf="isPrivate(owner)" class="column is-3">
          <label for="ownerBirthdateInput" class="label is-size-7">Geburtsdatum</label>
          <input class="border-input" type="date" id="ownerBirthdateInput" formControlName="birthDate"
                 [ngClass]="{'has-error': FormUtils.hasError(owner.get('birthDate'))}"
                 min="1900-01-01" [max]="maxBirthDate">
        </div>

        <div *ngIf="isCompany(owner)" class="column is-4">
          <label for="ownerCompanyInput" class="label is-size-7">Firma</label>
          <input class="border-input" type="text" id="ownerCompanyInput" formControlName="company"
                 [ngClass]="{'has-error': FormUtils.hasError(owner.get('company'))}" [placeholder]="'Firma'">
        </div>
      </div>
    </div>
  </div>

  <!-- Add Button -->
  <div class="field mt-4">
    <button type="button" class="button is-outlined is-rounded is-small is-flex is-align-items-center"
            (click)="addObjectOwner()">
    <span class="icon is-small is-align-self-center mr-2">
      <svg xmlns="http://www.w3.org/2000/svg"
           width="15.989"
           height="15.989"
           viewBox="0 0 15.989 15.989">
        <path id="Icon_awesome-plus"
              data-name="Icon awesome-plus"
              d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z"
              transform="translate(0 -2.25)"
              fill="#707070"/>
      </svg>
    </span>
      <span>Weitere Eigentümer:in hinzufügen</span>
    </button>
  </div>
</form>
